import type { Cluster } from "~/types";

/* Returns whether the possible operations include `resource_version` as an optional argument,
   which will only be the case for agents running versions more recent than
   https://github.com/turbopuffer/tpuf-ctl-vendor/pull/1244 */
function setConfigAdvertisesResourceVersion(cluster: Cluster): boolean {
  const args = cluster.possible_operations.set_config?.arguments;
  return (
    typeof args === "object" && args !== null && "resource_version" in args
  );
}

export interface SetConfigOperationArguments {
  data: Record<string, string>;
  resource_version?: string;
}

export interface SetConfigCreateRequestBody
  extends SetConfigOperationArguments {
  operation: "set_config";
}

export interface SetConfigBuildOptions {
  /** ConfigMap resource version captured when editing started. */
  resourceVersion: string | null | undefined;
}

/** `arguments` for a `set_config` operation (Settings Overrides, ExtraFieldFormatter). */
export function buildSetConfigOperationArguments(
  data: Record<string, string>,
  cluster: Cluster,
  options: SetConfigBuildOptions,
): SetConfigOperationArguments {
  const args: SetConfigOperationArguments = { data };
  const { resourceVersion } = options;
  if (setConfigAdvertisesResourceVersion(cluster) && resourceVersion) {
    args.resource_version = resourceVersion;
  }
  return args;
}

/** JSON body for `POST /api/clusters/:id` when proposing `set_config`. */
export function buildSetConfigCreateRequestBody(
  data: Record<string, string>,
  cluster: Cluster,
  options: SetConfigBuildOptions,
): SetConfigCreateRequestBody {
  return {
    operation: "set_config",
    ...buildSetConfigOperationArguments(data, cluster, options),
  };
}
